export const AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC = 'aud_mobile_bx1047_single_pin_logic';
export const AUD_WEB_BX1274_PIN_UNIFICATION = 'aud_web_bx1274_pin_unification_redesign';
export const AUD_WEB_BX1125_EMPTY_LISTING_REDESIGN = 'aud_web_bx1125_empty_listing_redesign';

export const STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY = 'Martech.Stone3SPDesktopExperiment.Enabled';

export const EXPERIMENTS: string[] = [
  AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC,
  AUD_WEB_BX1274_PIN_UNIFICATION,
  AUD_WEB_BX1125_EMPTY_LISTING_REDESIGN,
];
